import React, { useRef } from "react";
import Slider from "react-slick";
import { IoArrowBackCircleOutline } from "react-icons/io5"; // Make sure to import from 'react-icons/io5' for the latest version
import "./index.css";

import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

const Carousel = ({ children, breakPoints }) => {
  const sliderRef = useRef(null);

  const nextSlide = () => {
    sliderRef.current.slickNext();
  };

  const previousSlide = () => {
    sliderRef.current.slickPrev();
  };
  const settings = {
    infinite: true,
    speed: 500,
    slidesToShow: 4,
    slidesToScroll: 1,
    responsive: [
      {
        breakpoint: breakPoints? 1280 : 1024,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1,
          infinite: true,
        },
      },
      {
        breakpoint: breakPoints? 1024 : 600,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: breakPoints? 600 : 480,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
    ],
  };

  return (
    <>
      <Slider ref={sliderRef} {...settings}>
        {children}
      </Slider>
      <div className="mt-12 flex flex-row justify-start my-12 ">
        <button className="button text-5xl mx-4" onClick={previousSlide}>
          <svg
            width="72"
            height="72"
            viewBox="0 0 72 72"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <rect
              x="0.5"
              y="0.5"
              width="71"
              height="71"
              rx="35.5"
              stroke="#E5E5E5"
            />
            <path
              d="M44.3334 35.9999C44.3334 36.4607 43.9609 36.8332 43.5001 36.8332H30.5117L34.9226 41.244C35.2484 41.5699 35.2484 42.0966 34.9226 42.4225C34.7601 42.585 34.5467 42.6665 34.3334 42.6665C34.1201 42.6665 33.9068 42.585 33.7443 42.4225L27.9109 36.5891C27.5851 36.2633 27.5851 35.7365 27.9109 35.4107L33.7443 29.5774C34.0701 29.2515 34.5967 29.2515 34.9226 29.5774C35.2484 29.9032 35.2484 30.4299 34.9226 30.7558L30.5117 35.1665H43.5001C43.9609 35.1665 44.3334 35.539 44.3334 35.9999Z"
              fill="#ED8B00"
            />
          </svg>
        </button>
        <button className="button text-5xl mx-4 " onClick={nextSlide}>
          <svg
            width="72"
            height="72"
            viewBox="0 0 72 72"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <rect
              x="0.5"
              y="0.5"
              width="71"
              height="71"
              rx="35.5"
              stroke="#ED8B00"
            />
            <rect
              x="0.5"
              y="0.5"
              width="71"
              height="71"
              rx="35.5"
              fill="#F6F6F6"
              stroke="#181A1F"
            />
            <path
              d="M44.089 35.4109L38.2557 29.5775C38.0932 29.415 37.8799 29.3335 37.6666 29.3335C37.4532 29.3335 37.2399 29.415 37.0774 29.5775C36.7516 29.9034 36.7516 30.4301 37.0774 30.756L41.4882 35.1668L28.4999 35.1668C28.0391 35.1668 27.6666 35.5393 27.6666 36.0001C27.6666 36.461 28.0391 36.8335 28.4999 36.8335L41.4882 36.8335L37.0774 41.2442C36.7516 41.5701 36.7516 42.0968 37.0774 42.4226C37.4032 42.7484 37.9298 42.7484 38.2557 42.4226L44.089 36.5893C44.4148 36.2635 44.4148 35.7367 44.089 35.4109Z"
              fill="#ED8B00"
            />
          </svg>
        </button>
      </div>
    </>
  );
};

export default Carousel;
